import { Card as ANTDCard, Avatar, Typography, Space, Modal, Flex } from 'antd'
import { Profile } from '../../models/Profile'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import {
  selectProfileById,
  setSelectedProfileWithSlug,
} from '../../store/ProfileReducer'
import { Subscription } from '../subscription/Subscription'
import { ConditionalLinkWrapper } from '../../modules/sbrm/components/ContionalWrappers'
import { useState } from 'react'
import { PricingTable } from './PricingTable'
import i18n from '../../i18n/setupLocalization'
import LocalizationKeys from '../../i18n/LocalizationKeys'
import { isSubscriptionValid } from '../../models/Billing'

const { Title, Text } = Typography

interface Props {
  id?: number
  model?: Profile
}

export const ProfileCard = ({ id, model }: Props) => {
  const dispatch = useAppDispatch()
  const profile = id ? useAppSelector(selectProfileById(id)) : model
  const [showPricingTable, setShowPricingTable] = useState<boolean>(false)

  if (!profile) return <></>

  const automationIsActive =
    profile.activeAutomations && profile.activeAutomations > 0

  return (
    <>
      <ConditionalLinkWrapper
        condition={isSubscriptionValid(profile.subscription)}
        onClick={() => {
          dispatch(setSelectedProfileWithSlug(profile.slug))
        }}
        to={
          `/profiles/${profile.slug}` +
          (profile.firstAutomationUlid
            ? `/automations/${profile.firstAutomationUlid}`
            : `/contacts/list`)
        }
      >
        <ANTDCard
          className={`profile-card big-border-purple `}
          onClick={() => {
            if (!isSubscriptionValid(profile.subscription)) {
              // No billing info available for this profile
              // Open a modal with the princing table
              setShowPricingTable(true)
              return
            }
          }}
        >
          <Space size={15}>
            <Avatar src={profile.instagram.profilePicture} size={50} />
            <Space direction="vertical" size={5}>
              <Title className="m-0" level={5}>
                {profile.name}
              </Title>
              <Space direction="vertical">
                <Space>
                  {automationIsActive ? (
                    <>
                      <div className="dot"></div>
                      {i18n.t(
                        LocalizationKeys.Component.Profile.Card.AutomationIsLive
                      )}
                    </>
                  ) : (
                    <Text type="secondary">
                      {i18n.t(
                        LocalizationKeys.Component.Profile.Card
                          .AutomationIsPaused
                      )}
                    </Text>
                  )}
                </Space>
                <Subscription.StatusTag subscription={profile.subscription} />
              </Space>
            </Space>
          </Space>
        </ANTDCard>
      </ConditionalLinkWrapper>
      {showPricingTable && (
        <Modal
          title={i18n.t(
            LocalizationKeys.Component.Profile.Card.ChoosePlanForUser,
            {
              username: `@${profile.instagram.username}`,
            }
          )}
          open
          width={'100%'}
          closable={false}
          footer={null}
        >
          <Flex
            vertical
            style={{ textAlign: 'center', width: '100%' }}
            gap={20}
          >
            <Space direction="vertical">
              <Title level={3} className="m-0">
                {i18n.t(LocalizationKeys.Component.Profile.ConnectFlow.Welcome)}
              </Title>
              <Text>
                {i18n.t(
                  LocalizationKeys.Component.Profile.ConnectFlow.ChoosePlan
                )}
              </Text>
            </Space>
            <PricingTable profileSlug={profile.slug} />
          </Flex>
        </Modal>
      )}
    </>
  )
}

export type ProfileCardType = { Card: typeof ProfileCard }
